module.exports = __webpack_public_path__ + "img/7.977af2b1.jpg";